import React from 'react'
import { INode } from 'shared/types/tree'
import { NodeIdMap } from '../version_mapping/utility'
import { Button } from '@mui/material'
import {
  NodeSearchParams,
  openNode,
  openNodeOnTKatBuilder,
} from '../utility/TreeNavigation'

export function OpenNodeButton({
  node,
  idMap,
}: {
  node: INode
  idMap?: NodeIdMap
}) {
  return <Button onClick={() => openNode(node, idMap)}>Open In Kiddom</Button>
}

export function OpenNodeTKatBuilderButton({
  node,
}: {
  node: NodeSearchParams
}) {
  return (
    <Button onClick={() => openNodeOnTKatBuilder(node)}>
      Open In TKat Builder
    </Button>
  )
}
